import config from '../data/demandTypes.json';

export const getDemandTypeLabel = (code) => {
  if (code == null || code === '') return '';
  const key = String(code).toUpperCase();
  return config.label[key] ?? String(code);
};

export const getDemandTypeFilterOptions = () =>
  Object.keys(config.label).map((key) => ({
    value: config.value[key] ?? key,
    label: config.label[key],
  }));

export const DEMAND_TYPE_FILTER_OPTIONS = getDemandTypeFilterOptions();
export const DEMAND_TYPE_VALUES = DEMAND_TYPE_FILTER_OPTIONS.map((option) => option.value);

export const setDemandTypeRegistry = (definitions) => {
  if (!Array.isArray(definitions) || definitions.length === 0) return;

  const options = definitions
    .filter((definition) => definition?.code && definition.active !== false)
    .map((definition) => ({
      value: String(definition.code).toUpperCase(),
      label: definition.label || definition.code,
    }));

  if (options.length > 0) {
    DEMAND_TYPE_FILTER_OPTIONS.splice(0, DEMAND_TYPE_FILTER_OPTIONS.length, ...options);
    DEMAND_TYPE_VALUES.splice(0, DEMAND_TYPE_VALUES.length, ...options.map((option) => option.value));
  }
};
